export const enableCard = (totalPoints, cardPoints) => {
    return totalPoints === cardPoints || totalPoints > cardPoints;
}